import "./App.css";
import { Component } from "react";

import GifSearch from "./components/Search/Search.jsx";
import GifList from "./components/List/GifList.jsx";

import { AppWrapper, Container, Title } from "./App.styled.js";

class App extends Component {
  state = {
    keyword: "cat",
  };

  handleSearch = (word) => {
    this.setState({ keyword: word });
  };

  render() {
    return (
      <AppWrapper>
        <Container>
          <Title>GIF Search</Title>

          <GifSearch onSearch={this.handleSearch} />
          <GifList keyword={this.state.keyword} />
        </Container>
      </AppWrapper>
    );
  }
}

export default App;
